<!-- eslint-disable vue/valid-v-slot -->
<template>
  <div>
    <v-data-table :headers="headers" :items="desserts" sort-by="ID_Cargador" class="elevation-1 custom-table notranslate" translate="no"
      :search="search" dense fixed-header :dark="$vuetify.theme.dark">
      <template v-slot:top>
        <v-overlay :value="loading">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </v-overlay>
        <v-snackbar v-model="NotiExito" :timeout="3000" color="success" top right>
          <span v-text="notiMessage"></span>
          <template v-slot:action="{ attrs }">
            <v-btn text v-bind="attrs" @click="NotiExito = false">
              Cerrar
            </v-btn>
          </template>
        </v-snackbar>
        <v-snackbar v-model="notiError" :timeout="5000" color="error" top right>
          <span v-text="errorMessage"></span>
          <template v-slot:action="{ attrs }">
            <v-btn text v-bind="attrs" @click="notiError = false">
              Cerrar
            </v-btn>
          </template>
        </v-snackbar>
        <div class="table-toolbar">
          <div class="table-toolbar__left">
            <span class="table-toolbar__title">Cargadores</span>
          </div>
          <div class="table-toolbar__right">
            <div class="table-search-wrap">
              <v-icon small color="rgba(255,255,255,0.4)">mdi-magnify</v-icon>
              <input v-model="search" type="text" class="table-search" placeholder="Buscar..." />
            </div>

            <v-dialog v-model="dialog" max-width="500px" :persistent="loading">
              <template v-slot:activator="{ on, attrs }">
                <button class="table-btn table-btn--primary" v-bind="attrs" v-on="on"
                  @click="creacion = true" :disabled="loading">+ Inscribir Cargador</button>
              </template>
              <div class="table-dialog">
                <div class="table-dialog__header">
                  <span class="table-dialog__title">{{ formTitle }}</span>
                </div>
                <div class="table-dialog__body">
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="editedItem.Nombre" label="Nombre" @input="validateName" :dark="$vuetify.theme.dark"
                          :rules="[(v) => !!v || 'Nombre es requerido', (v) => /^[a-zA-ZáéíóúñÁÉÍÓÚ\s]+$/.test(v) || 'Ingrese solo letras en el nombre']"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="editedItem.Apellido" label="Apellido" @input="validateLastName" :dark="$vuetify.theme.dark"
                          :rules="[(v) => !!v || 'Apellido es requerido', (v) => /^[a-zA-ZáéíóúñÁÉÍÓÚ\s]+$/.test(v) || 'Ingrese solo letras en el apellido']"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="editedItem.Altura" label="Altura" @input="validateHeight" :dark="$vuetify.theme.dark"
                          :rules="[(v) => !!v || 'Altura es requerida', (v) => /^\d{1,2}(\.\d{1,2})?$/.test(v) || 'Ingrese un número válido de altura']"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" v-if="creacion">
                        <v-menu :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y>
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="editedItem.fechaNacimiento" label="Fecha nacimiento" readonly :dark="$vuetify.theme.dark"
                              v-bind="attrs" v-on="on"
                              :rules="[(v) => !!v || 'Fecha nacimiento es requerido']"></v-text-field>
                          </template>
                          <v-date-picker v-model="editedItem.fechaNacimiento" no-title></v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="editedItem.Direccion" label="Dirección" :dark="$vuetify.theme.dark"
                          :rules="[(v) => !!v || 'Dirección es requerido']"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="editedItem.Telefono" label="Telefono" :dark="$vuetify.theme.dark"
                          :error-messages="errors.Telefono"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="editedItem.Correo" label="Correo" :dark="$vuetify.theme.dark"
                          :error-messages="errors.Correo"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="editedItem.Documento_Identificacion" label="CUI" @input="validateCUI" :dark="$vuetify.theme.dark"
                          :rules="cuiRules"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </div>
                <div class="table-dialog__actions">
                  <v-snackbar v-model="notiRequerido" :timeout="5000" color="warning" top>
                    <div class="subtitle-1 font-weight-bold">Completa el formulario</div>
                    <div v-text="msgRequerido"></div>
                    <template v-slot:action="{ attrs }">
                      <v-btn text v-bind="attrs" @click="notiRequerido = false">Cerrar</v-btn>
                    </template>
                  </v-snackbar>
                  <button class="table-btn table-btn--ghost" @click="close" :disabled="loading">Cancelar</button>
                  <button class="table-btn table-btn--primary" @click="save" :disabled="loading || !formValidate">Guardar</button>
                </div>
              </div>
            </v-dialog>

            <v-dialog v-model="dialogDelete" max-width="500px" :persistent="loading">
              <div class="table-dialog">
                <div class="table-dialog__header">
                  <span class="table-dialog__title">⚠️ Confirmar eliminación</span>
                  <p class="table-dialog__sub">¿Estás seguro que deseas eliminar a <strong>{{ editedItem.Nombre }}</strong>?</p>
                </div>
                <div class="table-dialog__actions">
                  <button class="table-btn table-btn--ghost" @click="closeDelete" :disabled="loading">No, cancelar</button>
                  <button class="table-btn table-btn--danger" @click="deleteItemConfirm" :disabled="loading">Sí, eliminar</button>
                </div>
              </div>
            </v-dialog>
          </div>
        </div>
      </template>
      <template v-slot:item.ID_Cargador="{ item }"><span v-text="item.ID_Cargador"></span></template>
      <template v-slot:item.Nombre="{ item }"><span v-text="item.Nombre"></span></template>
      <template v-slot:item.Apellido="{ item }"><span v-text="item.Apellido"></span></template>
      <template v-slot:item.Altura="{ item }"><span v-text="item.Altura"></span></template>
      <template v-slot:item.Fecha_Registro="{ item }"><span v-text="item.Fecha_Registro"></span></template>
      <template v-slot:item.Direccion="{ item }"><span v-text="item.Direccion"></span></template>
      <template v-slot:item.Documento_Identificacion="{ item }"><span v-text="item.Documento_Identificacion"></span></template>
      <template v-slot:item.Telefono="{ item }"><span v-text="item.Telefono"></span></template>
      <template v-slot:item.Correo="{ item }"><span v-text="item.Correo"></span></template>
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
        <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
    <!-- Dialog de sesión expirada -->
    <v-dialog v-model="showSessionExpiredDialog" max-width="400">
      <v-card>
        <v-card-title>¡Sesión expirada!</v-card-title>
        <v-card-text>Tu sesión ha expirado. Por favor, inicia sesión nuevamente.</v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="redirectToLogin">Iniciar sesión</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: {
    cargadores: [],
  },
  data: () => ({
    errors: {},
    showSessionExpiredDialog: false,
    dialog: false,
    formValidate: true,
    loading: false,
    dialogDelete: false,
    NotiExito: false,
    notiMessage: "",
    notiRequerido: false,
    msgRequerido: "",
    notiError: false,
    errorMessage: "",
    search: "",
    cuiRequerido: "S",
    creacion: false,
    // cuiVisible: false,
    validToken: false,
    headers: [
      {
        text: "CargadorID",
        align: "start",
        sortable: false,
        value: "ID_Cargador",
      },
      { text: "Nombre", value: "Nombre" },
      { text: "Apellido", value: "Apellido" },
      { text: "Altura", value: "Altura" },
      { text: "FechaRegistro", value: "Fecha_Registro" },
      { text: "Dirección", value: "Direccion", sortable: false },
      { text: 'CUI', value: 'Documento_Identificacion' },
      { text: "Telefono", value: "Telefono" },
      { text: "Correo", value: "Correo" },
      // { text: 'Tipo', value: 'Tipo_cargador' },
      { text: "Actions", value: "actions", sortable: false },
    ],
    desserts: [
      {
        ID_Cargador: 1,
        Nombre: "Sangría",
        Apellido: "Sangría",
        Fecha_Nacimiento: "2024-01-01T00:00:00.000Z",
        Altura: "2.00",
        Fecha_Registro: "2024-01-01T00:00:00.000Z",
        Direccion: "0",
        "Documento_Identificacion": "0",
        Estado: "A",
        Telefono: "0",
        Correo: "0",
        // "Tipo_cargador": "cargador"
      },
    ],
    editedIndex: -1,
    editedItem: {
      ID_Cargador: "",
      Nombre: "",
      Apellido: "",
      Altura: "",
      Fecha_Registro: "",
      fechaNacimiento: "",
      Direccion: "",
      Documento_Identificacion: '',
      Telefono: "",
      Correo: "",
      // Tipo_cargador: ''
    },
    defaultItem: {
      ID_Cargador: "",
      Nombre: "",
      Apellido: "",
      Altura: "",
      Fecha_Registro: "",
      fechaNacimiento: "",
      Direccion: "",
      Documento_Identificacion: '',
      Telefono: "",
      Correo: "",
      // Tipo_cargador: ''
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Crear Cargador" : "Editar Cargador";
    },
    cuiRules() {

      const requerido = this.cuiRequerido === 'S';

      return [
        v => (!requerido && !v) || !!v || 'CUI es requerido', // Solo requerido si cuiRequerido es 'S'
        v => (!v || v.length === 13) || 'El CUI debe tener 13 dígitos', // Solo valida si hay algo escrito
        v => (!v || /^\d+$/.test(v)) || 'Ingrese solo números en el CUI' // Solo valida si hay algo escrito
      ];
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    cargadores: {
      handler(newCargadores) {
        if (newCargadores.length > 0) {
          this.initialize();
        }
      },
      deep: true,
    },
    "editedItem.Correo"(newValue, oldValue) {
      // Validar el correo electrónico solo si ha cambiado
      if (newValue !== oldValue) {
        if (this.editedItem.Correo && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.editedItem.Correo)) {
          this.errors.Correo = "Ingrese un correo válido";
        } else { this.errors.Correo = "" }

      }
    },
    "editedItem.Telefono"(newValue, oldValue) {
      // Validar el correo electrónico solo si ha cambiado
      if (newValue !== oldValue) {
        if (this.editedItem.Telefono && !/^\d{8}$/.test(this.editedItem.Telefono)) {
          this.errors.Telefono = "Ingrese un número de teléfono válido"
        } else { this.errors.Telefono = "" }
      }
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    redirectToLogin() {
      const allCookies = this.$cookies.keys();
      for (const cookie of allCookies) {
        this.$cookies.remove(cookie);
      }

      // Redirigir al usuario al componente de inicio de sesión
      this.$router.push("/sistema");
    },
    validateName() {
      const regex = /^[a-zA-ZáéíóúñÁÉÍÓÚ\s]+$/;
      if (!regex.test(this.editedItem.Nombre)) {
        this.editedItem.Nombre = this.editedItem.Nombre.slice(0, -1);
        this.formValidate = false;
      } else {
        this.formValidate = true;
      }
    },
    validateLastName() {
      const regex = /^[a-zA-ZáéíóúñÁÉÍÓÚ\s]+$/;
      if (!regex.test(this.editedItem.Apellido)) {
        this.editedItem.Apellido = this.editedItem.Apellido.slice(0, -1);
        this.formValidate = false;
      } else {
        this.formValidate = true;
      }
    },
    validateHeight() {
      const regex = /^\d{1,2}(\.\d{1,2})?$/;
      if (!regex.test(this.editedItem.Altura)) {
        this.editedItem.Altura = this.editedItem.Altura.slice(0, -1);
        this.formValidate = false;
      } else {
        this.formValidate = true;
      }
    },
    validatePhoneNumber() {
      const regex = /^\d{0,8}$/;
      if (!regex.test(this.editedItem.Telefono)) {
        this.editedItem.Telefono = this.editedItem.Telefono.slice(0, -1);
        this.formValidate = false;
      } else {
        this.formValidate = true;
      }
    },
    validateEmail() {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!regex.test(this.editedItem.Correo)) {
        this.editedItem.Correo = this.editedItem.Correo.slice(0, -1);
        this.formValidate = false;
      } else {
        this.formValidate = true;
      }
    },
    validateCUI() {
      const regex = /^\d+$/;
      let valor = this.editedItem.Documento_Identificacion || '';

      if (!regex.test(valor)) {
        this.editedItem.Documento_Identificacion = valor.replace(/\D/g, '');
      }

      if (valor.length > 13) {
        this.editedItem.Documento_Identificacion = valor.slice(0, 13);
      }

      // Si CUI es requerido, valida la longitud, si no, permite vacío
      if (this.cuiRequerido === 'S') {
        this.formValidate = this.editedItem.Documento_Identificacion.length === 13;
      } else {
        this.formValidate = this.editedItem.Documento_Identificacion.length === 13 || this.editedItem.Documento_Identificacion === '';
      }
    },
    hideNotification() {
      // Logic handled by v-snackbar automatically
    },
    initialize() {
      this.validateToken();
      this.desserts = this.cargadores;
      this.cuiRequerido = this.$cookies.get('cuiReq')
    },

    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
      // if (this.editedItem.Documento_Identificacion.length < 13) {
      //   this.cuiVisible = true
      // }
    },

    deleteItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    async deleteItemConfirm() {
      this.desserts.splice(this.editedIndex, 1);
      await this.OrquestaEliminacion();
      this.closeDelete();
      // this.EliminaCargador()
    },

    close() {
      this.dialog = false;
      this.creacion = false;

      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async save() {
      this.errors = {};//Reiniciar errores antes de validar
      this.msgRequerido = "";
      this.notiRequerido = false;
      this.validaReq();

      if (this.editedItem.Telefono && !/^\d{8}$/.test(this.editedItem.Telefono)) {
        this.errors.Telefono = "Ingrese un número de teléfono válido"
      }

      if (this.editedItem.Correo && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.editedItem.Correo)) {
        this.errors.Correo = "Ingrese un correo válido";
      }

      if (this.notiRequerido || Object.keys(this.errors).length > 0) {
        // this.creacion = false
        return;
      }

      try {
        if (this.editedIndex > -1) {
          Object.assign(this.desserts[this.editedIndex], this.editedItem);
          await this.ActualizaCargador();
        } else {
          await this.creaCargador();
          // this.desserts.push(this.editedItem)
        }
        this.close();
      } catch (error) {
        // console.error('error al guardar el cargador: ', error)
      }
    },
    validaReq() {
      this.msgRequerido = "Los campos ";
      if (!this.editedItem.Nombre) {
        this.notiRequerido = true;
        this.msgRequerido = this.msgRequerido + "Nombre";
      }
      if (!this.editedItem.Apellido) {
        this.notiRequerido = true;
        this.msgRequerido = this.msgRequerido + ", Apellido";
      }
      if (!this.editedItem.Altura) {
        this.notiRequerido = true;
        this.msgRequerido = this.msgRequerido + ", Altura";
      }
      if (!this.editedItem.fechaNacimiento && this.creacion) {
        this.notiRequerido = true;
        this.msgRequerido = this.msgRequerido + ", Fecha nacimiento";
      }
      if (!this.editedItem.Direccion) {
        this.notiRequerido = true;
        this.msgRequerido = this.msgRequerido + ", Dirección";
      }
      if (this.cuiRequerido === 'S' && !this.editedItem.Documento_Identificacion) {
        this.notiRequerido = true;
        this.msgRequerido = this.msgRequerido + ", CUI";
      }
      // if (!this.editedItem.Tipo_cargador) {
      //     this.notiRequerido = true
      //     this.msgRequerido = this.msgRequerido + ", Tipo de cargador"
      // }
      this.msgRequerido = this.msgRequerido + " son requeridos.";
    },
    async OrquestaEliminacion() {
      this.loading = true;
      await this.validateToken();
      if (!this.validToken) {
        // localStorage.clear
        this.clearAllCookies();
        return;
      }
      const token = this.$cookies.get("token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      const idCargador = this.editedItem.ID_Cargador;
      await this.EliminaCargador(idCargador, config);

      // await this.EliminaInscripcion(idCargador,config);
      this.loading = false;
    },
    clearAllCookies() {
      const allCookies = this.$cookies.keys();
      for (const cookie of allCookies) {
        this.$cookies.remove(cookie);
      }
    },
    EliminaCargador(idCargador, config) {
      const apiUrl = `https://62jecp6v6f.execute-api.us-east-1.amazonaws.com/dev/api/cargadores/${idCargador}?usuarioResponsable=${this.$cookies.get("username")}`;

      return axios
        .delete(apiUrl, config)
        .then(() => {
          // this.loading = false;
          this.notiMessage = "El cargador ha sido eliminado correctamente";
          this.NotiExito = true;
        })
        .catch(() => {
          // console.error('Error al obtener datos de la API', error);
          this.errorMessage = "Hubo un problema en la eliminación del cargador, ";
          this.notiError = true;
          this.hideNotification();
          // this.loading = false;
        });
    },

    async creaCargador() {
      this.loading = true;
      await this.validateToken();
      if (!this.validToken) {
        // localStorage.clear
        this.clearAllCookies();
        //this.$router.push('/sistema');
        return;
      }

      // Configurar el token de autorización en el encabezado de la solicitud
      // const token = localStorage.getItem('token');
      const token = this.$cookies.get("token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      const bodyReq = {
        nombre: this.editedItem.Nombre,
        apellido: this.editedItem.Apellido,
        fechaNacimiento: this.editedItem.fechaNacimiento,
        altura: this.editedItem.Altura,
        direccion: this.editedItem.Direccion,
        documentoIdentificacion: this.editedItem.Documento_Identificacion,
        telefono: this.editedItem.Telefono,
        correo: this.editedItem.Correo,
        sexo: "M",
        usuarioResponsable: this.$cookies.get("username"), //localStorage.username
      };
      const apiUrl = "https://62jecp6v6f.execute-api.us-east-1.amazonaws.com/dev/api/cargadores";

      // Enviar la solicitud para crear un nuevo cargador

      return axios
        .post(apiUrl, bodyReq, config)
        .then((response) => {
          this.editedItem.ID_Cargador = response.data.cargadorId;
          this.editedItem.Fecha_Registro = response.data.fechaRegistro;
          this.desserts.push(this.editedItem);

          this.loading = false;
          this.notiMessage = "El cargador ha sido creado correctamente";
          this.NotiExito = true;
          this.hideNotification();
        })
        .catch((error) => {
          this.loading = false;
          // console.error('Error al crear el cargador:', error);

          this.errorMessage = error.response.data.message;
          this.notiError = true;
          this.msgRequerido = error.response.data.message;
          this.notiRequerido = true;
          this.hideNotification();
          throw error;
        });
    },
    validateToken() {
      // const token = localStorage.token
      const token = this.$cookies.get("token");
      // this.loading = true;
      const apiUrl = `https://wm1xvvtarj.execute-api.us-east-1.amazonaws.com/dev/validateToken?token=${token}`;
      // Configuración para la solicitud GET con el token en el encabezado Authorization

      return axios
        .get(apiUrl)
        .then((response) => {
          const username = response.data.decoded.username;
          this.$cookies.set("username", username, "1d", "", "", true, "Strict");

          // localStorage.username = response.data.decoded.username;
          this.validToken = true;
          // this.loading = false; // Desactivar animación de carga
        })
        .catch(() => {
          this.validToken = false;
          this.showSessionExpiredDialog = true;
          // console.error(error)
          // console.error('Error al obtener datos de la API', error);
          // this.loading = false; // Desactivar animación de carga en caso de error
        });
    },
    async ActualizaCargador() {
      this.loading = true;
      const idCargador = this.editedItem.ID_Cargador;
      await this.validateToken();
      if (!this.validToken) {
        // localStorage.clear
        this.clearAllCookies();
        return;
      }
      const apiUrl = `https://62jecp6v6f.execute-api.us-east-1.amazonaws.com/dev/api/cargadores/${idCargador}`;
      const token = this.$cookies.get("token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const bodyReq = {
        nombre: this.editedItem.Nombre,
        apellido: this.editedItem.Apellido,
        fechaNacimiento: this.editedItem.fechaNacimiento,
        altura: this.editedItem.Altura,
        direccion: this.editedItem.Direccion,
        telefono: this.editedItem.Telefono,
        correo: this.editedItem.Correo,
        usuarioResponsable: this.$cookies.get("username"), //localStorage.username
        documentoIdentificacion: this.editedItem.Documento_Identificacion
      };

      axios
        .put(apiUrl, bodyReq, config)
        .then(() => {

          // this.cuiVisible = false;
          this.loading = false;
          this.notiMessage = "El cargador ha sido actualizado correctamente";
          this.NotiExito = true;
          this.hideNotification();
        })
        .catch((error) => {
          this.loading = false;
          this.errorMessage = "Hubo un problema en la actualización del cargador, " + error.response.data.message;
          this.notiError = true;
          this.msgRequerido = "Hubo un problema en la actualización del cargador, " + error.response.data.message;
          this.notiRequerido = true;
          this.hideNotification();
        });
    },
  },
};
</script>

<style scoped>
.custom-table {
  width: auto;
  max-width: 100%;
  margin: 0 auto;
  overflow-x: auto;
}

/* ── Toolbar dark ── */
.table-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 16px 20px;
  background: var(--sys-card-bg);
  border-bottom: 1px solid var(--sys-card-border);
  font-family: 'Inter', sans-serif;
}

.table-toolbar__title {
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--sys-text-primary);
}
.table-toolbar__right {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

/* Search input */
.table-search-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
  background: var(--sys-input-bg);
  border: 1px solid var(--sys-card-border);
  border-radius: 8px;
  padding: 7px 14px;
  transition: border-color 0.2s;
}
.table-search-wrap:focus-within {
  border-color: rgba(123,47,247,0.6);
}
.table-search {
  background: transparent;
  border: none;
  outline: none;
  color: var(--sys-text-primary);
  font-family: 'Inter', sans-serif;
  font-size: 0.88rem;
  width: 160px;
}
.table-search::placeholder { color: var(--sys-text-secondary); }

/* Buttons */
.table-btn {
  padding: 8px 18px;
  border-radius: 8px;
  font-family: 'Inter', sans-serif;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
  white-space: nowrap;
}
.table-btn--primary {
  background: linear-gradient(135deg, #7b2ff7, #4a1b9a);
  color: #fff;
  box-shadow: 0 4px 14px rgba(123,47,247,0.3);
}
.table-btn--primary:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(123,47,247,0.5);
}
.table-btn--primary:disabled { opacity: 0.5; cursor: not-allowed; }
.table-btn--ghost {
  background: transparent;
  color: var(--sys-text-secondary);
  border: 1px solid var(--sys-card-border);
}
.table-btn--ghost:hover { background: var(--sys-input-bg); color: var(--sys-text-primary); }
.table-btn--danger {
  background: rgba(239,68,68,0.15);
  color: #fca5a5;
  border: 1px solid rgba(239,68,68,0.3);
}
.table-btn--danger:hover { background: rgba(239,68,68,0.25); }

/* Dialog */
.table-dialog {
  background: var(--sys-dialog-bg);
  border: 1px solid var(--sys-card-border);
  border-radius: 18px;
  padding: 28px 24px;
  font-family: 'Inter', sans-serif;
}
.table-dialog__header { margin-bottom: 20px; }
.table-dialog__title {
  font-size: 1.15rem;
  font-weight: 800;
  color: var(--sys-text-primary);
  display: block;
  margin-bottom: 6px;
}
.table-dialog__sub {
  font-size: 0.9rem;
  color: var(--sys-text-secondary);
  margin: 0;
}
.table-dialog__body { margin-bottom: 24px; }
.table-dialog__actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 16px;
  border-top: 1px solid rgba(123,47,247,0.12);
}

/* Inputs del form en el dialog (Vuetify dark override) */
[data-theme="dark"] ::v-deep .table-dialog .v-input__slot {
  background: rgba(255,255,255,0.05) !important;
}
::v-deep .table-dialog .v-label {
  color: var(--sys-text-secondary) !important;
}
::v-deep .table-dialog input {
  color: var(--sys-text-primary) !important;
}
</style>